import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MetaService } from './shared/service/meta.service';
import { Spinkit } from 'ng-http-loader';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  spinnerStyle = Spinkit;
  @Input() public spinnerBackgroundColor!: string
 // title = 'ClientApp';
  isSticky: boolean = false
  metaData: any
  constructor(private title: Title, private meta: Meta, private metaService: MetaService){
    
  }
  @HostListener('scroll', ['$event'])
  windoScroll(){
    if(window.screenY > 120){
      this.isSticky = true
    }
  }

  ngOnInit(): void {
    // this.metaService.getmeta().subscribe((res:any) => {
    //   this.metaData = res.data.home;
    //   //console.log(res)
      
    //   //console.log(this.metaData)
    //    this.title.setTitle( this.metaData.title)
    //    this.meta.addTags([  
    //      { name: 'keywords', content: this.metaData.keyword },  
    //      { name: 'description', content: this.metaData.description },  
    //      { name: 'author', content: this.metaData.author },  
    //    ]); 
    //   })
  }
}
